// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__jFpQp","greyColor":"PageTitle_greyColor__cdLrs","subheader":"PageTitle_subheader__wFseZ"};